import firebase from 'firebase/app'
import 'firebase/auth'
import gen from '../gen'

const state = {
  emailPassword_login_email: '',
  emailPassword_login_password: ''
}

const getters = {

}

const mutations = {
  //
  emailPassword_login(state2, payload){
    //console.log(payload)
    //
    gen.state.btnLoader = true
    //
    let email = payload.email
    let password = payload.password
    //
    firebase
      .auth()
      .signInWithEmailAndPassword(email, password)
      .then(()=>{

        gen.mutations.snackbar_alert(state, {
          msg: 'Logged In Successfully !'
        })
        //
        state.emailPassword_login_email = ''
        state.emailPassword_login_password = ''
        //
        //route
        gen.mutations.goTo(state, '/')
        //
        gen.state.btnLoader = false

      }).catch(function(error) {
      // Handle Errors here.
      var errorCode = error.code;
      var errorMessage = error.message;
      // ...
      gen.mutations.snackbar_alert(state, {
        msg: error.message
      })
      //
      gen.state.btnLoader = false
      //
    });
    //
  }
}

const actions = {

}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/auth/emailPassword_login.js